export default {

  boms: [],
  bom: {},
  bomCode: null,
  bomCommodities: [],

  bomByCode: {},

  bomNavigation: {},

  setting: {},

  production: [],
  productionItem: {},
  productionNavigation: {},
  productionCode: {},

  productionDetailsReport: [],

  productionCalculate: {},

  productionCostsReport: [],
 
  producedProductsReport: [],
  consumedRawMaterials: [],

};
